<template>
    <div class="vue-treeselect__value-container">
        <TransitionGroup tag="div" name="vue-treeselect__multi-value-item--transition" class="vue-treeselect__multi-value" :appear="true">
            <MultiValueItem v-for="node of items" :key="`multi-value-item-${node.id}`" :node="node" />

            <div v-if="count > 0" class="vue-treeselect__limit-tip vue-treeselect-helper-zoom-effect-off" key="exceed-limit-tip">
                <span class="vue-treeselect__limit-tip-text">{{ instance.limitText( count ) }}</span>
            </div>

            <Placeholder key="placeholder" />
            <Input ref="input" key="input" />
        </TransitionGroup>
    </div>
</template>

<script>
import MultiValueItem   from './MultiValueItem.vue';
import Input            from './Input.vue';
import Placeholder      from './Placeholder.vue';

export default
{
    name       : 'Treeselect--multi-value',
    inject     : [ 'instance' ],
    components : { MultiValueItem, Input, Placeholder },
    computed   :
    {
        items()
        {
            const { instance } = this;

            return instance.internalValue.slice( 0, instance.limit ).map( instance.getNode );
        },

        count()
        {
            const { instance } = this;

            return instance.internalValue.length - instance.limit;
        }
    },
    methods:
    {
        /*
        renderMultiValueItems()
        {
            const { instance } = this;

            return instance.internalValue.slice( 0, instance.limit ).map( instance.getNode ).map( node => ( <MultiValueItem key={`multi-value-item-${node.id}`} node={node} /> ) );
        },
        */

        /*
        renderExceedLimitTip()
        {
            const { instance } = this;

            const count = instance.internalValue.length - instance.limit;

            if( count <= 0 )
            {
                return null;
            }

            return (
                <div class="vue-treeselect__limit-tip vue-treeselect-helper-zoom-effect-off" key="exceed-limit-tip">
                    <span class="vue-treeselect__limit-tip-text">{ instance.limitText(count) }</span>
                </div>
            )
        }
        */
    },

    /*
    render()
    {
        const { renderValueContainer } = this.$parent;

        return renderValueContainer(
            <TransitionGroup class="vue-treeselect__multi-value" tag="div" name="vue-treeselect__multi-value-item--transition" appear={true} >
                {this.renderMultiValueItems()}
                {this.renderExceedLimitTip()}
                <Placeholder key="placeholder" />
                <Input ref="input" key="input" />
            </TransitionGroup>,
        )
    }
    */
}
</script>
